import { Organization } from '@models/Organization';
import { Loader } from '@shared/designSystem/Loader';
import styles from '@styles/screens/ReporteScreen.module.css';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Application } from '@core/Application';

interface ReportesScreenProps {
	org: Organization;
}

interface ReportLocationState {
	metabaseQuestionCode: number;
	metabaseResourceType?: 'question' | 'dashboard';
}

const ReporteScreen: React.FC<ReportesScreenProps> = ({ org }) => {
	const navigate = useNavigate();

	const location = useLocation();
	const state = location.state as ReportLocationState | undefined;

    const [iframeUrl, setIframeUrl] = useState<string | null>(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!state?.metabaseQuestionCode) {
            navigate('/reports', { replace: true });
            return;
        }

        const fetchMetabaseToken = async () => {
            try {
                const resourceType = state.metabaseResourceType || 'question';
                const metabaseService = Application.shared().coreDependencies.metabaseService;
                const json = await metabaseService.getToken(state.metabaseQuestionCode.toString(), resourceType);

                const METABASE_SITE_URL = "https://qeeptouch.metabaseapp.com";
                const METABASE_TOKEN = json;
                setIframeUrl(`${METABASE_SITE_URL}/embed/${resourceType}/${METABASE_TOKEN}#titled=true`);
            } catch (error) {
                console.error('Error fetching Metabase token:', error);
                setError('Failed to load report. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchMetabaseToken();
    }, [state, navigate]);

    if (!state?.metabaseQuestionCode) return null;

    return (
        <div className={styles['content-block']}>
            <div className={styles['header-container']}>
                <div className={styles['title-container']}>
                    <h2 className={styles['title']} style={{gap: '10px'}}>
                        <div className={styles['svg-container']} style={{width: '45px', height: '45px', cursor: 'pointer'}} onClick={() => {navigate(-1)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 36 36" fill="none">
                                <path d="M21.375 11.625L14.625 18L21.375 24.375" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        Reporte
                    </h2>
                </div>
            </div>

            {loading && 
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                    <Loader height="80px" width="80px" />
                </div>
            }
            {iframeUrl && (
                <iframe
                    src={iframeUrl}
                    style={{display: 'flex', flexGrow: 1, border: 'none'}}
                    title="Report Dashboard"
                    onError={() => setError('Failed to load report frame.')}
                />
            )}
        </div>
    );
};

export default ReporteScreen;
